/**
 * Real product logos (in their own colours) for the server catalog: operating
 * systems, server apps and Docker app templates. Bundled under
 * public/static/img/logos/ (each one's source is in SOURCES.md there) and
 * looked up by catalog slug, so a new catalog item gets its logo by adding the
 * file and a line here. A logo the backend sends (`logo_url`, or an `icon` that
 * is a URL) always wins.
 *
 * Order matters for the loose match (the first key found in the item's slug /
 * template / OS / name wins), so more specific keys come first.
 */
const LOGOS = [
  ['uptime-kuma', 'uptime-kuma.svg'],
  ['hermes-agent', 'hermes-agent.png'],
  ['openclaw', 'openclaw.png'],
  ['paperclip', 'paperclip.svg'],
  ['buzz', 'buzz.svg'],
  ['wordpress', 'wordpress.png'],
  ['gitea', 'gitea.svg'],
  ['grafana', 'grafana.svg'],
  ['n8n', 'n8n.svg'],
  ['ollama', 'ollama.svg'],
  ['chroma', 'chroma.svg'],
  ['gogs', 'gogs.svg'],
  ['postgres', 'postgresql.svg'],
  ['mongo', 'mongodb.svg'],
  ['redis', 'redis.svg'],
  ['metabase', 'metabase.svg'],
  ['umami', 'umami.svg'],
  ['ghost', 'ghost.svg'],
  ['mattermost', 'mattermost.svg'],
  ['jitsi', 'jitsi.png'],
  ['syncthing', 'syncthing.svg'],
  ['nextcloud', 'nextcloud.svg'],
  ['plex', 'plex.svg'],
  ['jellyfin', 'jellyfin.svg'],
  ['lychee', 'lychee.svg'],
  ['home-assistant', 'home-assistant.png'],
  ['nginx', 'nginx.svg'],
  ['docker', 'docker.svg'],
  ['ubuntu', 'ubuntu.png'],
  ['debian', 'debian.svg'],
  ['almalinux', 'almalinux.svg'],
  ['rocky', 'rockylinux.svg'],
  ['fedora', 'fedora.png'],
  ['centos', 'centos.svg'],
]

const isUrl = v => typeof v === 'string' && /^https?:\/\//i.test(v)

/**
 * The logo image URL for a catalog item, or null.
 * @param {Object} item any of { logo_url, icon, slug, template, os, app, name }
 */
export function logoUrl (item) {
  if (!item) return null
  if (isUrl(item.logo_url)) return item.logo_url
  if (isUrl(item.icon)) return item.icon
  const keys = [item.slug, item.template, item.os, item.app].filter(Boolean).map(k => String(k).toLowerCase())
  const exact = LOGOS.find(([k]) => keys.includes(k))
  const hay = `${keys.join(' ')} ${String(item.name || '').toLowerCase()}`
  const hit = exact || LOGOS.find(([k]) => hay.includes(k))
  return hit ? `/static/img/logos/${hit[1]}` : null
}

/** An icon (Material Design name) for an item with no logo. */
export function fallbackIcon (item, defaultIcon = 'mdi-application') {
  const icon = item && item.icon
  return typeof icon === 'string' && icon.startsWith('mdi-') ? icon : defaultIcon
}
